// import './index.scss';
import React, { useEffect, useState } from 'react';
import Logo from "../../components/general/logo"
import qs from 'qs';
import {
    AutoComplete,
    Button,
    DatePicker,
    Checkbox,
    Col,
    Form,
    Input,
    InputNumber,
    Row,
    Select,
} from 'antd';

import { BaseUrlAuth } from '../../utils';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { errorHandling } from '../../utils/helper';

const formRules: object[] = [
    {
        type: 'email',
        message: 'The input is not valid E-mail!',
    },
    {
        required: true,
        message: 'Please input your E-mail!',
    },
];

const VerifyEmail: React.FC = (): JSX.Element => {
    const [form] = Form.useForm();
    const location = useLocation();
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [message, setMessage] = useState<string>('');

    const [authData, setAuthData] = useState<any>({
        email: '',
    });

    const handleAuthDataChange = (e: any) => {
        setAuthData((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = () => {
        axios
            .post(BaseUrlAuth + `/api/v1/auth/request-verify-token`, authData, {
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .then((res) => {
                setMessage('Verification token sent.Check your email.');
            })
            .catch((error) => {

                console.log(error);
            });
    };

    return (
        <div className="signin-page">
            <div style={{ marginTop: '25vh' }}>
                <Logo {...{ size: 'large' }} />
            </div>

            <Form
                form={form}
                name="register"
                onFinish={handleSubmit}
                scrollToFirstError
            >
                <div className="container-xxl signup-container">
                    <div className="row">
                        <p style={{ color: 'green' }}>{message}</p>
                        <div className="col">
                            <Form.Item
                                className="input-field email"
                                name="email"
                                label=""
                                rules={formRules}
                            >
                                <Input
                                    placeholder="Email"
                                    name="email"
                                    onChange={handleAuthDataChange}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <Form.Item
                                className="input-field Sign-Up-Button"
                                style={{ paddingTop: '0px', marginBottom: '0px' }}
                            >
                                <Button type="primary" htmlType="submit">
                                    Send Verification Email
                                </Button>
                            </Form.Item>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    );
};

export default VerifyEmail;
